@if (control) {
  <div class="label-row">
    <label [for]="id" [class]="classBindings">
      <ng-content></ng-content>
    </label>
    @if (isOptional) {
      <label
        class="small grey-7"
        >
        {{ 'common.optional' | translate }}
      </label>
    }
  </div>
  <div class="input-wrapper"
    [class]="classBindings"
    >
    @if (theme === 'search') {
      <span
        appIcon="search"
        class="search-icon"
      ></span>
    }
    @if (type !== 'textarea') {
      <input
        (blur)="blurEvents$.next({ programmatic: false })"
        [formControl]="control"
        [value]="control.value"
        [type]="type"
        [id]="id"
        [attr.min]="min"
        [attr.max]="max"
        [attr.step]="step"
        [attr.placeholder]="placeholder"
        [attr.disabled]="disabled ? 'disabled' : null"
        >
    }
    @if (type === 'textarea') {
      <div
        class="textarea-wrapper"
        >
        <textarea (blur)="blurEvents$.next({ programmatic: false })"
          [formControl]="control"
          [id]="id"
          [attr.placeholder]="placeholder"
          [attr.disabled]="disabled ? 'disabled' : null"
          [attr.maxlength]="maxLength"
        ></textarea>
        @if (counter) {
          <label
            class="small grey-7"
            >
            <span>
              {{ control.value.length }} / {{ maxLength }}
            </span>
          </label>
        }
      </div>
    }
    @if (!noValidate && !icon && theme === 'input' && (type !== 'textarea') && (type !== 'time') && validationStateIcons[validationState]; as icon) {
      <div
        [appIcon]="icon"
        class="state-icon"
      ></div>
    }
    @if (icon && theme === 'input') {
      <span
        (click)="fireEvent()"
        [appIcon]="icon"
        class="icon"
      ></span>
    }
    @if (validationState === 'pending') {
      <div
        class="loader"
      ></div>
    }
    @if (currentErrorMessage$ | async; as message) {
      <div
        class="error-message"
        >
        {{ message | translate }}
      </div>
    }
    @if (form && fieldName && ! noValidate) {
      <app-validation-errors
        [form]="form"
        [field]="fieldName"
      ></app-validation-errors>
    }
  </div>
}
